import { render } from "./index.vue?vue&type=template&id=61568e5e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=61568e5e&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=61568e5e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61568e5e"]])

export default __exports__